module.exports = __webpack_public_path__ + "74ad10a2df816f9cbf42d5f715a88866.svg";